import { useState, useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
import { VERIFY_STORE, VERIFY_STORE_BY_API_KEY } from '../graphql/queries';

export const useAuth = ({ token, apiKey }) => {
  const [authState, setAuthState] = useState({
    isAuthenticated: false,
    isLoading: true,
    error: null,
    store: null,
  });

  const [verifyStore, { data: tokenData, error: tokenError, loading: tokenLoading }] =
    useLazyQuery(VERIFY_STORE, { fetchPolicy: 'network-only' });

  const [verifyStoreByApiKey, { data: apiKeyData, error: apiKeyError, loading: apiKeyLoading }] =
    useLazyQuery(VERIFY_STORE_BY_API_KEY, { fetchPolicy: 'network-only' });

  // Fire the matching query as soon as we have a credential
  useEffect(() => {
    if (apiKey) {
      verifyStoreByApiKey({ variables: { apiKey } });
      return;
    }
    if (token) {
      verifyStore({ variables: { token } });
      return;
    }
    setAuthState({ isAuthenticated: false, isLoading: false, error: 'No credential provided', store: null });
  }, [token, apiKey]); // eslint-disable-line react-hooks/exhaustive-deps

  // React to query result changes
  useEffect(() => {
    const loading = tokenLoading || apiKeyLoading;
    if (loading) return;

    const error = tokenError || apiKeyError;
    if (error) {
      setAuthState({ isAuthenticated: false, isLoading: false, error: error.message, store: null });
      return;
    }

    const result = apiKeyData?.verifyStoreByApiKey || tokenData?.verifyStore;
    if (!result) return;

    if (result.error) {
      setAuthState({ isAuthenticated: false, isLoading: false, error: result.message, store: null });
    } else {
      if (result.storeType) {
        sessionStorage.setItem('websiteType', result.storeType);
      }
      setAuthState({
        isAuthenticated: true,
        isLoading: false,
        error: null,
        store: {
          clientId: result.clientId,
          storeId: result.storeId,
          storeName: result.storeName,
          storeType: result.storeType,
        },
      });
    }
  }, [tokenData, tokenError, tokenLoading, apiKeyData, apiKeyError, apiKeyLoading]);

  return authState;
};
